import { Component } from "react";
import * as React from "react";
import { gray } from "../../styles/Colors";

import "./SectionHeader.css";

interface ISectionHeaderProps {
    title: string;
    titleColor: string;
    subtitle: string;
    subtitleColor: string;
}

export class SectionHeader extends Component<ISectionHeaderProps> {
    constructor(props: ISectionHeaderProps) {
        super(props);
    }

    public render() {
        return (
            <div className="section-header">
                <h1 style={{ color: this.props.titleColor }}>{this.props.title.trim().toUpperCase()}</h1>
                <hr style={{ borderColor: gray }}/>
                <h2 style={{ color: this.props.subtitleColor }}>{this.props.subtitle.trim()}</h2>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/visual/SectionHeader.tsx